import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { adminPoolsBackend } from './admin-pools.backend';
import { adminPoolsReducer } from './admin-pools.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('adminPools', adminPoolsReducer),
    BackendModule.forFeature('adminPools', adminPoolsBackend),
  ],
})
export class DatastoreAdminPoolsModule {}
